module.exports = __webpack_public_path__ + "static/form-grouping-dont-77faf49dd5d8f58156ce76000daf2e37.png";